// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "./node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "./node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DateInput {
  width: 112px !important;
}
.DateRangePickerInput_arrow {
  font-size: 18px !important;
  margin-top: 1rem !important;
  align-self: center;
  position: relative;
  justify-self: center;
}
.daterangepicker {
  top: 0;
  left: 0;
  border: none;
  background-color: transparent !important;
}
.DateInput_input {
  border: none !important;
  background-color: transparent !important;
  font-size: 15px !important;
  font-weight: bold !important;
}
.DateRangePicker_picker {
  z-index: 99 !important;
  min-height: 338px;
  transform: translateY(-1px);
}

.DateRangePicker_picker > div {
  min-height: 338px;
}

.DateRangePickerInput {
  display: grid !important;
  grid-template-columns: 1fr 32px 1fr;
}

.DateInput {
  background-color: transparent !important;
}
.DateRangePickerInput {
  background-color: transparent !important;
}
.DateRangePickerInput_arrow_svg {
  height: 16px;
  width: 16px;
}

.main-search_dates {
  position: relative;
}

.daterange-actions {
  display: block;
  position: absolute;
  bottom: -380px;
  z-index: 100;
  height: 50px;
  width: 310px;
}

.daterange-actions.--confirm {
  background-color: var(--main-color);
  color: #fff;
  transform: translateX(100%);
}

.daterange-actions.--cancel {
  background-color: #e2e2e2;
  color: #545454;
  left: 20px;
}

@media (max-width: 599px) {
  .hide-chat {
    display: none !important;
  }

  .DateRangePicker_picker.DateRangePicker_picker_1 {
    position: fixed;
    width: 100vw;
    left: 0;
    bottom: 0;
    transform: translateY(0);
  }

  .DayPicker > div,
  .DayPicker > div > div,
  .DayPicker_transitionContainer,
  .DayPicker .DayPicker_focusRegion {
    height: 100% !important;
  }

  .DateInput_fang {
    top: 60px !important;
  }

  .DateInput {
    z-index: 100;
    /* position: fixed !important; */
  }

  /* .DateInput:last-of-type {
    left: 40%;
  } */

  .DateRangePickerInput {
    display: grid !important;
    grid-template-columns: 1fr 32px 1fr;
  }

  .DateRangePickerInput_arrow {
    align-self: center;
    position: relative;
    z-index: 100;
    justify-self: center;
  }

  .main-search_mobile-filters .cta.update.--dates-open {
    position: relative;
    z-index: 100;
  }

  .CalendarMonthGrid__vertical {
    width: 95% !important;
  }

  .CalendarMonthGrid__vertical div:nth-child(3) .CalendarMonth_caption {
    padding-bottom: 8px;
    padding-top: 20px;
  }

  .daterange-actions {
    display: block;
    position: fixed;
    bottom: 0;
    z-index: 10000;
    height: 50px;
    width: 50%;
  }

  .daterange-actions.--confirm {
    left: 50%;
    transform: none;
  }

  .daterange-actions.--cancel {
    left: 0;
  }

  .DayPickerNavigation_svg__vertical {
    height: 28px;
    width: 28px;
    fill: var(--main-color);
  }

  .DayPickerNavigation_button__verticalDefault {
    width: 40px;
    height: 40px;
    position: fixed;
  }

  .DayPickerNavigation_nextButton__verticalDefault {
    right: 0;
    transform: translateY(-50%);
  }

  .DayPickerNavigation_prevButton__verticalDefault {
    left: 0;
  }

  .DayPickerNavigation_nextButton__verticalDefault svg {
    transform: rotate(-90deg);
  }

  .DayPickerNavigation_prevButton__verticalDefault svg {
    transform: rotate(-90deg);
  }
}

.DayPickerKeyboardShortcuts_buttonReset {
  display: none;
}

.main-search_dates .CalendarDay__selected {
  background: var(--main-color) !important;
}

.main-search_dates .CalendarDay__selected_span {
  background: var(--main-color-50) !important;
}

#map iframe + div {
  border: none !important;
}

.DateRangePicker:before {
  display: none;
}

.DateInput_input {
  cursor: pointer;
  padding-right: 0 !important;
  padding-top: 5px !important;
  position: relative;
  z-index: 1000000;
  order: 2;
}

.date-picker-label {
  font-size: .7rem;
  font-weight: 500;
  color: #545454;
  display: block !important;
  padding-left: 10px;
  line-height: 1;
  padding-top: 10px;
  margin-bottom: 3px;
  order: 1;
}

.DateInput:focus-within .date-picker-label {
  color: var(--main-color);
}

.DateInput_fang {
  display: none;
}

.DateInput_input.DateInput_input__focused {
  box-shadow: none !important;
  border-top: 1px solid #ececec !important;
  border-left: 1px solid #ececec !important;
  border-right: 1px solid #ececec !important;
  background: #fff !important;
  border-radius: 5px 5px 0 0;
  color: #545454 !important;
  cursor: text;
  box-shadow: 0 -0.5px 1px rgba(0,0,0,.15)!important;
}

.DateInput_input.DateInput_input__focused ~ .date-picker-label {
  color: var(--main-color);
}

.DateInput {
  display: flex;
  flex-direction: column;
}`, "",{"version":3,"sources":["webpack://./datepicker.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;AACzB;AACA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,kBAAkB;EAClB,kBAAkB;EAClB,oBAAoB;AACtB;AACA;EACE,MAAM;EACN,OAAO;EACP,YAAY;EACZ,wCAAwC;AAC1C;AACA;EACE,uBAAuB;EACvB,wCAAwC;EACxC,0BAA0B;EAC1B,4BAA4B;AAC9B;AACA;EACE,sBAAsB;EACtB,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,wBAAwB;EACxB,mCAAmC;AACrC;;AAEA;EACE,wCAAwC;AAC1C;AACA;EACE,wCAAwC;AAC1C;AACA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,YAAY;EACZ,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,mCAAmC;EACnC,WAAW;EACX,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,UAAU;AACZ;;AAEA;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,eAAe;IACf,YAAY;IACZ,OAAO;IACP,SAAS;IACT,wBAAwB;EAC1B;;EAEA;;;;IAIE,uBAAuB;EACzB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,YAAY;IACZ,gCAAgC;EAClC;;EAEA;;KAEG;;EAEH;IACE,wBAAwB;IACxB,mCAAmC;EACrC;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;IAClB,YAAY;IACZ,oBAAoB;EACtB;;EAEA;IACE,kBAAkB;IAClB,YAAY;EACd;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,mBAAmB;IACnB,iBAAiB;EACnB;;EAEA;IACE,cAAc;IACd,eAAe;IACf,SAAS;IACT,cAAc;IACd,YAAY;IACZ,UAAU;EACZ;;EAEA;IACE,SAAS;IACT,eAAe;EACjB;;EAEA;IACE,OAAO;EACT;;EAEA;IACE,YAAY;IACZ,WAAW;IACX,uBAAuB;EACzB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,QAAQ;IACR,2BAA2B;EAC7B;;EAEA;IACE,OAAO;EACT;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,2BAA2B;EAC3B,2BAA2B;EAC3B,kBAAkB;EAClB,gBAAgB;EAChB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,QAAQ;AACV;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,2BAA2B;EAC3B,wCAAwC;EACxC,yCAAyC;EACzC,0CAA0C;EAC1C,2BAA2B;EAC3B,0BAA0B;EAC1B,yBAAyB;EACzB,YAAY;EACZ,kDAAkD;AACpD;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB","sourcesContent":[".DateInput {\n  width: 112px !important;\n}\n.DateRangePickerInput_arrow {\n  font-size: 18px !important;\n  margin-top: 1rem !important;\n  align-self: center;\n  position: relative;\n  justify-self: center;\n}\n.daterangepicker {\n  top: 0;\n  left: 0;\n  border: none;\n  background-color: transparent !important;\n}\n.DateInput_input {\n  border: none !important;\n  background-color: transparent !important;\n  font-size: 15px !important;\n  font-weight: bold !important;\n}\n.DateRangePicker_picker {\n  z-index: 99 !important;\n  min-height: 338px;\n  transform: translateY(-1px);\n}\n\n.DateRangePicker_picker > div {\n  min-height: 338px;\n}\n\n.DateRangePickerInput {\n  display: grid !important;\n  grid-template-columns: 1fr 32px 1fr;\n}\n\n.DateInput {\n  background-color: transparent !important;\n}\n.DateRangePickerInput {\n  background-color: transparent !important;\n}\n.DateRangePickerInput_arrow_svg {\n  height: 16px;\n  width: 16px;\n}\n\n.main-search_dates {\n  position: relative;\n}\n\n.daterange-actions {\n  display: block;\n  position: absolute;\n  bottom: -380px;\n  z-index: 100;\n  height: 50px;\n  width: 310px;\n}\n\n.daterange-actions.--confirm {\n  background-color: var(--main-color);\n  color: #fff;\n  transform: translateX(100%);\n}\n\n.daterange-actions.--cancel {\n  background-color: #e2e2e2;\n  color: #545454;\n  left: 20px;\n}\n\n@media (max-width: 599px) {\n  .hide-chat {\n    display: none !important;\n  }\n\n  .DateRangePicker_picker.DateRangePicker_picker_1 {\n    position: fixed;\n    width: 100vw;\n    left: 0;\n    bottom: 0;\n    transform: translateY(0);\n  }\n\n  .DayPicker > div,\n  .DayPicker > div > div,\n  .DayPicker_transitionContainer,\n  .DayPicker .DayPicker_focusRegion {\n    height: 100% !important;\n  }\n\n  .DateInput_fang {\n    top: 60px !important;\n  }\n\n  .DateInput {\n    z-index: 100;\n    /* position: fixed !important; */\n  }\n\n  /* .DateInput:last-of-type {\n    left: 40%;\n  } */\n\n  .DateRangePickerInput {\n    display: grid !important;\n    grid-template-columns: 1fr 32px 1fr;\n  }\n\n  .DateRangePickerInput_arrow {\n    align-self: center;\n    position: relative;\n    z-index: 100;\n    justify-self: center;\n  }\n\n  .main-search_mobile-filters .cta.update.--dates-open {\n    position: relative;\n    z-index: 100;\n  }\n\n  .CalendarMonthGrid__vertical {\n    width: 95% !important;\n  }\n\n  .CalendarMonthGrid__vertical div:nth-child(3) .CalendarMonth_caption {\n    padding-bottom: 8px;\n    padding-top: 20px;\n  }\n\n  .daterange-actions {\n    display: block;\n    position: fixed;\n    bottom: 0;\n    z-index: 10000;\n    height: 50px;\n    width: 50%;\n  }\n\n  .daterange-actions.--confirm {\n    left: 50%;\n    transform: none;\n  }\n\n  .daterange-actions.--cancel {\n    left: 0;\n  }\n\n  .DayPickerNavigation_svg__vertical {\n    height: 28px;\n    width: 28px;\n    fill: var(--main-color);\n  }\n\n  .DayPickerNavigation_button__verticalDefault {\n    width: 40px;\n    height: 40px;\n    position: fixed;\n  }\n\n  .DayPickerNavigation_nextButton__verticalDefault {\n    right: 0;\n    transform: translateY(-50%);\n  }\n\n  .DayPickerNavigation_prevButton__verticalDefault {\n    left: 0;\n  }\n\n  .DayPickerNavigation_nextButton__verticalDefault svg {\n    transform: rotate(-90deg);\n  }\n\n  .DayPickerNavigation_prevButton__verticalDefault svg {\n    transform: rotate(-90deg);\n  }\n}\n\n.DayPickerKeyboardShortcuts_buttonReset {\n  display: none;\n}\n\n.main-search_dates .CalendarDay__selected {\n  background: var(--main-color) !important;\n}\n\n.main-search_dates .CalendarDay__selected_span {\n  background: var(--main-color-50) !important;\n}\n\n#map iframe + div {\n  border: none !important;\n}\n\n.DateRangePicker:before {\n  display: none;\n}\n\n.DateInput_input {\n  cursor: pointer;\n  padding-right: 0 !important;\n  padding-top: 5px !important;\n  position: relative;\n  z-index: 1000000;\n  order: 2;\n}\n\n.date-picker-label {\n  font-size: .7rem;\n  font-weight: 500;\n  color: #545454;\n  display: block !important;\n  padding-left: 10px;\n  line-height: 1;\n  padding-top: 10px;\n  margin-bottom: 3px;\n  order: 1;\n}\n\n.DateInput:focus-within .date-picker-label {\n  color: var(--main-color);\n}\n\n.DateInput_fang {\n  display: none;\n}\n\n.DateInput_input.DateInput_input__focused {\n  box-shadow: none !important;\n  border-top: 1px solid #ececec !important;\n  border-left: 1px solid #ececec !important;\n  border-right: 1px solid #ececec !important;\n  background: #fff !important;\n  border-radius: 5px 5px 0 0;\n  color: #545454 !important;\n  cursor: text;\n  box-shadow: 0 -0.5px 1px rgba(0,0,0,.15)!important;\n}\n\n.DateInput_input.DateInput_input__focused ~ .date-picker-label {\n  color: var(--main-color);\n}\n\n.DateInput {\n  display: flex;\n  flex-direction: column;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
